const COOKIE_REGEX = /[()<>@,;"\\/[\]?={} \t]/g;
const isValidCookieValue = (name) => !COOKIE_REGEX.test(name);
const isValidCookie = (name, value) => isValidCookieValue(name) && isValidCookieValue(value);

export { isValidCookie };
